import React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    BooleanInput,
    required,
} from 'react-admin';

const DocumentTypeCreate = (props: any) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" validate={required()} />
            <TextInput
                source="code"
                validate={required()}
                helperText="Unique code (e.g., passport, civil_id)"
            />
            <TextInput source="description" multiline rows={3} />
            <BooleanInput
                source="isActive"
                label="Active"
                defaultValue={true}
            />
        </SimpleForm>
    </Create>
);

export default DocumentTypeCreate;
